import React, { useEffect, useRef } from "react";
import {
  Wrapper,
  Container,
  ImageWrapper,
  DragImageWrapper,
  DragImageContainer,
  DragImage,
} from "../styles/components/Galleries/Drag";
import {
  CreditsContainer,
  SmallHeading,
} from "../styles/components/Galleries/Global";
import { mm } from "../styles/variables/MatchMedia";
import { BREAKPOINTS } from "../styles/variables/Breakpoints";
import animations from "./Animations";

const DragGallery = ({ srcs, credits }) => {
  const wrapperRef = useRef(null);
  const imageRefs = useRef([null, null]);

  useEffect(() => {
    const mediaMatcher = mm();

    const sections = imageRefs.current;
    const scaleWrap = animations.utils.wrap(0, 1);

    const handleDrag = event => {
      wrapperRef.current?.classList.toggle("grabbing", event.isDragging);
      let currentX = event.x;
      let width = window.innerWidth;
      let scale = currentX / width;
      scale = scaleWrap(scale);

      let currentElement = sections[0];
      currentElement = currentElement?.querySelector(".drag");

      let nextElement = sections[1];
      nextElement = nextElement?.querySelector(".drag");

      const tl = animations.timeline({});

      tl.to(
        currentElement,
        {
          scaleX: scale,
          scaleY: 1,
          transformOrigin: "top left",
          duration: 0.1,
        },
        0
      ).to(
        nextElement,
        {
          scaleX: 1 - scale,
          scaleY: 1,
          transformOrigin: "top right",
          duration: 0.1,
        },
        0
      );
    };

    const handleRelease = () => {
      let maxScale = 0;
      let maxScaleIndex = 0;

      wrapperRef.current?.classList.toggle("grabbing", false);

      sections.forEach((section, index) => {
        let image = section.querySelector(".drag");
        const computedStyle = window.getComputedStyle(image);
        const matrix = new DOMMatrix(computedStyle.transform);
        const scaleXValue = matrix.a;

        if (scaleXValue > maxScale) {
          maxScale = scaleXValue;
          maxScaleIndex = index;
        }
      });

      sections.forEach((section, index) => {
        let image = section.querySelector(".drag");
        if (index === maxScaleIndex) {
          animations.to(image, {
            scaleX: 1,
            scaleY: 1,
            duration: 0.3,
          });
        } else {
          animations.to(image, {
            scaleX: 0,
            scaleY: 1,
            duration: 0.3,
          });
        }
      });
    };

    mediaMatcher.add(`(min-width: ${BREAKPOINTS.sm}px)`, context => {
      sections.forEach((section, index) => {
        let image = section?.querySelector(".drag");
        if (image && index !== 0) {
          animations.set(image, {
            scaleX: 0,
          });
        }
      });

      animations.Observer.create({
        target: wrapperRef.current,
        onDrag: event => handleDrag(event),
        onRelease: () => handleRelease(),
      });
    });
  }, []);

  return (
    <Wrapper>
      <Container ref={wrapperRef}>
        {srcs.map((src, index) => (
          <ImageWrapper
            key={index}
            ref={ref => (imageRefs.current[index] = ref)}
            $quote={index !== 0 && "quote"}
          >
            <DragImageWrapper className="drag">
              <DragImageContainer>
                <DragImage src={src} />
              </DragImageContainer>
            </DragImageWrapper>
          </ImageWrapper>
        ))}
      </Container>
      <CreditsContainer $justify="center">
        <SmallHeading>{credits}</SmallHeading>
      </CreditsContainer>
    </Wrapper>
  );
};

export default DragGallery;
